import { render, staticRenderFns } from "./projectPage.vue?vue&type=template&id=5c55f17c"
import script from "./projectPage.vue?vue&type=script&lang=js"
export * from "./projectPage.vue?vue&type=script&lang=js"
import style0 from "./projectPage.vue?vue&type=style&index=0&id=5c55f17c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports